import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de9bad6046f12a/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de9bad6046f12a/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de9bad6046f12a/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de9bad6046f12a/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de9bad6046f12a/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/app/[locale]/industries/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
